export default {
  name: 'skill-card',
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    },
    cardStyle: {
      type: Object,
      required: true
    },
    lineClamp: {
      type: Number
    }
  }
};